function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

import ContentEditable from 'react-contenteditable';

import './content-editable.scss';

var FloatEditor = function FloatEditor(_ref) {
  var value = _ref.value,
      field = _ref.field,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? {} : _ref$locale,
      onSelect = _ref.onSelect,
      onUpdate = _ref.onUpdate,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      autoSelect = _ref.autoSelect,
      props = _objectWithoutProperties(_ref, ['value', 'field', 'locale', 'onSelect', 'onUpdate', 'className', 'autoSelect']);

  var handleFocus = function handleFocus(e) {
    if (autoSelect) {
      window.getSelection().selectAllChildren(e.target);
    }
    onSelect(field, locale)(e);
  };
  var handleUpdate = function handleUpdate(blurring) {
    return function (e) {
      var input = e.target.value || e.target.textContent;
      if (input) {
        var _value = parseFloat((input.match(/\d*\.?\d*/g) || []).join('')) || null;
        onUpdate(field, locale, blurring)(_value, blurring);
      } else {
        onUpdate(field, locale, blurring)(null, blurring);
      }
    };
  };
  return React.createElement(ContentEditable, { className: 'content-editable ' + className,
    html: value ? value.toString() : '',
    onFocus: handleFocus,
    onChange: handleUpdate(),
    onBlur: handleUpdate(true)
  });
};
export { FloatEditor };